
/* eslint-disable */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiRunFast,
	mdiAccountDetails,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	mdiOfficeBuilding,
	mdiAccountConvert,
	mdiCalendar,
	mdiSoccer,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
	mdiSchool,
	mdiExclamationThick,
	mdiPencilOff,
	mdiComment,
	mdiGoogleClassroom,
	mdiBookshelf,
	mdiCashMultiple,
	mdiFlag,
	mdiCalendarAccount,
	mdiNeedle,
	mdiArrowUpBold,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiCalendarCursor,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiNotebookMultiple,
  mdiTableClock,
  mdiNotebookCheck,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiCalendarMonth,
	mdiBookOpenPageVariant,
	mdiBookEducationOutline,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiCurrencyUsd,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	mdiWatermark,
	mdiAccountMultiplePlus,
	mdiPen,
	mdiChartBar,
	mdiTagMultiple,
	mdiViewModule,
	mdiTrophyOutline
} from '@mdi/js'

const menuCourseAll = [
  {
    label: 'sidebarFin.master',
    // label: 'Master',
    subLabel: 'Submenus Master',
    icon: mdiCog,
    menu: [
      {
        to: '/academic-year',
        label: 'sidebarFin.acaYear',
        // label: 'Academic Year',
        icon: mdiCalendar
      },
      {
        to: '/financial-year',
        label: 'sidebarFin.finYear',
        // label: 'Financial Year',
        icon: mdiCalendarMonth
      },
      {
        to: '/academic-batch',
        label: 'sidebarFin.academicbatch',
        // label: 'Academic Batch',
        icon: mdiCalendarAccount
      },
      {
        to: '/department',
        label: 'sidebarFin.department',
        // label: 'Department',
        icon: mdiOfficeBuilding
      },
      {
        to: '/semester',
        label: 'sidebarFin.batch',
        // label: 'Batch',
        icon: mdiFlag
      },
      {
        to: '/level',
        label: 'level.title',
        // label: 'Level',
        icon: mdiArrowUpBold
      },
      {
        to: '/resignation-reason',
        label: 'sidebarFin.resignationReason',
        // label: 'Resignation Reason',
        icon: mdiBookOpenVariant
      },
      {
        to: '/class',
        label: 'sidebarFin.class',
        // label: 'Class',
        icon: mdiGoogleClassroom,
        updateMark: true
      },
      {
        to: '/work-unit',
        label: 'sidebarFin.workUnit',
        // label: 'Work Unit',
        icon: mdiOfficeBuilding,
        updateMark: true
      },
      {
        to: '/shift',
        label: 'sidebarFin.shift',
        // label: 'Shift',
        icon: mdiAccountConvert,
        updateMark: true
      },
      // {
      // 	to: '/extracuricular',
      // 	label: 'Extracuricular',
      // 	icon: mdiSoccer
      // },
      {
        to: '/vaccine',
        label: 'sidebarFin.vaccine',
        // label: 'Vaccine',
        icon: mdiNeedle
      },
      {
        to: '/comment',
        label: 'sidebarFin.comment',
        // label: 'Comment',
        icon: mdiComment
      },
      {
        to: '/batch-registration',
        label: 'sidebarFin.batchRegistration',
        // label: 'Batch Registration',
        icon: mdiCalendarCursor
      },
      {
        to: '/major',
        label: 'sidebarFin.major',
        // label: 'Major',
        icon: mdiSchool
      },
      {
        to: '/major-date',
        label: 'sidebarFin.event',
        // label: 'Event',
        icon: mdiSchool
      },
      {
        to: '/violation',
        label: 'sidebarFin.violation',
        // label: 'Violation',
        icon: mdiExclamationThick
      },
      {
        to: '/punishment',
        label: 'sidebarFin.punishment',
        // label: 'Punishment',
        icon: mdiPencilOff
      }
    ]
  },

  {
    label: 'sidebarFin.courseworkMaster',
    // label: 'Master Course',
    subLabel: 'Coursework Master',
    icon: mdiViewModule,
    menu: [
      {
        to: '/coursework',
        label: 'sidebarFin.coursework',
        // label: 'Coursework',
        icon: mdiBookEducationOutline
      },
      {
        to: '/price-group',
        label: 'sidebarFin.priceGroup',
        // label: 'Price Group',
        icon: mdiTagMultiple
      },
      // {
      // 	to: '/price-list',
      // 	label: 'Price List',
      // 	icon: mdiCurrencyUsd
      // },
      {
        to: '/non-academic-activity',
        label: 'sidebarFin.nonAcademicActivity',
        // label: 'Non-Academic Activities',
        icon: mdiRunFast
      }
    ]
  },
  {
    label: 'sidebarFin.courseworkAchievement',
    // label: 'Course Achievement',
    to: '/coursework-achievement',
    icon: mdiTrophyOutline
  },
  {
    label: 'sidebarFin.students',
    // label: 'Student',
    subLabel: 'Submenus Student',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/students',
        label: 'sidebarFin.students',
        // label: 'Students',
        icon: mdiAccountGroup
      },
      {
        to: '/class-transfer',
        label: 'sidebarFin.classTransfer',
        // label: 'Class Transfer',
        icon: mdiAccountMultiplePlus
      },
      {
        to: '/student-resignation',
        label: 'sidebarFin.resignation',
        // label: 'Resignation',
        icon: mdiAccountGroup
      },
      {
        to: '/graduation',
        label: 'sidebarFin.graduation',
        // label: 'Graduation',
        icon: mdiAccountSchool
      }
    ]
  },
  {
    label: 'sidebarFin.parents',
    // label: 'Parents',
    to: '/parent-user',
    icon: mdiAccount
  },
  {
    label: 'sidebarFin.employee',
    // label: 'Employee',
    subLabel: 'Employee',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/employee',
        label: 'sidebarFin.employee',
        // label: 'Employees',
        icon: mdiAccount
      }
    ]
  },
  {
    label: 'sidebarFin.subject',
    // label: 'Subject',
    subLabel: 'Submenus Subject',
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: '/subject',
        label: 'sidebarFin.subject',
        // label: 'Subject',
        icon: mdiBookshelf
      },
      {
        to: '/subject-group',
        label: 'sidebarFin.subjectGroup',
        // label: 'Subject Group',
        icon: mdiBookOpenPageVariant
      },
      {
        to: '/learning-method',
        label: 'sidebarFin.learningMethod',
        // label: 'Learning Method',
        icon: mdiBookPlusMultiple
      },
      {
        to: '/grading-aspects',
        label: 'sidebarFin.gradingAspects',
        // label: 'Grading Aspects',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/assignment-type',
        label: 'sidebarFin.assignmentType',
        // label: 'Assignment Type',
        icon: mdiFormatListBulletedType
      },
      {
        to: '/grading-rule',
        label: 'sidebarFin.gradingRule',
        // label: 'Grading Rule',
        icon: mdiFormatLetterMatches
      },
      {
        to: '/final-score-rule',
        label: 'sidebarFin.finalScoreRule',
        // label: 'Final Score Rule',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/scoreminimum',
        label: 'sidebarFin.passingGrade',
        // label: 'Passing Grade',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/syllabus',
        label: 'sidebarFin.syllabus',
        // label: 'Syllabus',
        icon: mdiNotebookEdit
      },
      {
        to: '/student-select-subject',
        label: 'sidebarFin.studentSelectSubject',
        // label: 'Student Subject Selection',
        icon: mdiAccountDetails
      }
    ]
  },
  {
    label: 'sidebarFin.extracurricular',
    // label: 'Extracuricular',
    subLabel: 'Submenus Extracuricular',
    icon: mdiSoccer,
    menu: [
      {
        to: '/extracuricular',
        label: 'sidebarFin.extracurricular',
        // label: 'Extracuricular',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-group',
        label: 'sidebarFin.extracuricularGroup',
        // label: 'Extracuricular Group',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-student',
        label: 'sidebarFin.extracurricularStudent',
        // label: 'Student Extracuricular',
        icon: mdiAccountDetails
      },
      {
        to: '/extracuricular-student-select',
        label: 'sidebarFin.extracurricularStudentSelect',
        // label: 'Student Extracuricular Selection',
        icon: mdiAccountDetails
      }
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ]
  },
  {
    label: 'sidebarFin.teacher',
    // label: 'Teacher',
    subLabel: 'Submenus Teacher',
    icon: mdiClipboardAccount,
    menu: [
      {
        to: '/teacher',
        label: 'sidebarFin.teacher',
        // label: 'Teacher',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/coursework-teacher',
        label: 'sidebarFin.courseworkTeacher',
        // label: 'Teachers Summary Report',
        icon: mdiNotebookMultiple
      },
      {
        to: '/teacher-timesheet',
        label: 'sidebarFin.teacherTimesheet',
        // label: 'Teacher Timesheet',
        icon: mdiTableClock
      },
      {
        to: '/completed-coursework',
        label: 'sidebarFin.completedCoursework',
        // label: 'Completed Coursework',
        icon: mdiNotebookCheck
      }
    ]
  },
  {
    label: 'sidebarFin.roles',
    // label: 'Roles',
    subLabel: 'Roles',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/role',
        label: 'sidebarFin.roles',
        // label: 'Role',
        icon: mdiFaceAgent
      },
      {
        to: '/role-group',
        label: 'sidebarFin.roleGroup',
        // label: 'Role Group',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'sidebarFin.transaction',
    // label: 'Transaction',
    subLabel: 'Transaction',
    icon: mdiCashMultiple,
    menu: [
      {
        to: '/transaction-type',
        label: 'sidebarFin.transactionType',
        // label: 'Transaction Type',
        icon: mdiCashMultiple
      },
      {
        to: '/transaction-group',
        label: 'sidebarFin.transactionGroup',
        // label: 'Transaction Group',
        icon: mdiCashMultiple
      }
    ]
  },
  {
    label: 'sidebarFin.permissionRequest',
    // label: 'Permission Request',
    subLabel: 'Submenus Teacher',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/permissions',
        label: 'sidebarFin.permissions',
        // label: 'Permissions',
        icon: mdiFaceAgent
      },
          {
        to: '/permission-reason',
        label: 'sidebarFin.permissionReason',
        // label: 'Permission Reason',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'sidebarFin.attendance',
    // label: 'Attendance',
    subLabel: 'Submenus Attendance',
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: '/regular-subject-attendance',
        label: 'sidebarFin.regularSubject',
        // label: 'Regular Subject',
        icon: mdiAccountArrowLeftOutline
      },
      {
        to: '/report-attendance-daily',
        label: 'sidebarFin.dailyAttendanceReport',
        // label: 'Daily Attendance Report',
        icon: mdiAccountAlert
      },
      {
        to: '/summary-report',
        label: 'sidebarFin.summaryReport',
        // label: 'Summary Report',
        icon: mdiAccountAlert
      },
      {
        to: '/assignment-special',
        label: 'sidebarFin.specialAssignment',
        // label: 'Special Assignment',
        icon: mdiBusDoubleDecker
      }
    ]
  },
  {
    label: 'sidebarFin.subjectAssessment',
    // label: 'Subject Assessment',
    subLabel: 'Submenus Subject Assessment',
    icon: mdiSchool,
    menu: [
      {
        to: '/lesson-assessment-regular',
        label: 'sidebarFin.regular',
        // label: 'Regular',
        icon: mdiSchool
      },
      {
        to: '/ledger-homeroom-teacher',
        label: 'sidebarFin.homeroomLedger',
        // label: 'Homeroom Ledger',
        icon: mdiSchool
      },
      {
        to: '/extracuricular-score',
        label: 'sidebarFin.extracuricularScore',
        // label: 'Extracuricular Score',
        icon: mdiSchool
      }
    ]
  },
  {
    label: 'sidebarFin.settings',
    // label: 'Settings',
    subLabel: 'Submenus Settings',
    icon: mdiCog,
    menu: [
      {
        to: '/schoolidentity',
        label: 'sidebarFin.schoolIdentity',
        // label: 'School Identity',
        icon: mdiSchool
      },
      {
        to: '/branch',
        label: 'sidebarFin.branch',
        // label: 'Branch',
        icon: mdiWatermark
      },
      {
        to: '/users',
        label: 'sidebarFin.users',
        // label: 'Users',
        icon: mdiAccount
      },
      {
        to: '/settingattendance',
        label: 'sidebarFin.settingAttendance',
        // label: 'Setting Attendance',
        icon: mdiPen
      },
      {
        to: '/settingspeed',
        label: 'sidebarFin.chartAnalysisSetting',
        // label: 'Chart & Analysis Setting',
        icon: mdiChartBar
      },
      {
        to: '/template-announcement',
        label: 'sidebarFin.templateAnnouncement',
        // label: 'Template Announcement',
        icon: mdiSchool
      }
    ]
  }
]
export default menuCourseAll
